import React, { useEffect, useRef, useState } from "react";


const statusClasses = {
  All: "bg-[#536493]",
  "In Progress": "bg-[#6F6EDE]",
  "Action Required": "bg-[#F26666]",
  "Requested Follow Up": "bg-[#FABC3F]",
  Qualified: "bg-[#15B392]",
  Booked: "bg-[#66D062]",
  "DNQ Criteria Not Met": "bg-[#CBA35C]",
  "DNQ Other": "bg-[#CBA35C]",
  "DNQ No Response": "bg-[#CBA35C]",
  "DNQ Not Interested": "bg-[#CBA35C]",
  "Non-textable": "bg-[#D73A60]",
  "To-call": "bg-[#605EA1]",
  "Contact Attempt 1": "bg-[#F28E58]",
  "Contact Attempt 2": "bg-[#F28E58]",
  "Contact Attempt 3": "bg-[#F28E58]",
  "Scheduled Screen": "bg-[#AA5486]",
};

const StatusPatientChange = ({ options, initialValue, onSelect, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  //const [selectedOption, setSelectedOption] = useState(initialValue);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const dropdownRef = useRef(null);

  // useEffect(() => {
  //   setSelectedOption(initialValue);
  // }, [initialValue]);

  useEffect(() => {
    setFilteredOptions(
      options.filter((option) =>
        option.statusName.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, options]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleOptionClick = (option) => {
    //setSelectedOption(option.statusName); // Update the button text
    setIsOpen(false); // Close the dropdown
    onSelect(option); // Trigger the onSelect callback with the selected option
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="py-1 rounded-full  transition-all duration-500"
      >
        <span
          className={`flex justify-between items-center text-xs text-gray-500 rounded-3xl px-2 ml-[12px] py-2 status-bubble ${statusClasses[initialValue] || "bg-gray-200"
            }`}
        >
          {initialValue}&nbsp;&nbsp;&nbsp;
          <svg className="rotate-90" width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.75 13L7.58333 7L1.75 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </span>
      </button>

      {isOpen && (
        <div className={`${className} absolute top-[35px] left-[-20px] z-30 p-2 mt-2 bg-white rounded shadow-md w-[250px] border light_border_color`}>
          <div className="flex items-center border rounded-lg p-2 mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-5 h-5 text-black-400"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 104.35 4.35a7.5 7.5 0 0012.3 12.3z"
              />
            </svg>
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              placeholder="Search..."
              className="w-full outline-none ml-2 text-sm"
            />
          </div>
          <ul className={`max-h-[400px] overflow-y-auto`}>

            {filteredOptions.length > 0 ? (
              filteredOptions.map((option) => (
                <li
                  key={option.statusID}
                  onClick={() => handleOptionClick(option)}
                  className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                >
                  <span className="hidden">{option.normalizedStatus}</span>
                  {option.statusName}
                </li>
              ))
            ) : (
              <li className="px-4 py-2 text-gray-500">No results found</li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default StatusPatientChange;